import React from "react";
import { Box, Button, Flex, Spacer, Text } from "@chakra-ui/react";
import ImageComponent from "./ImageComponent";

const NavBarComponent = () => {
  const image = {
    url: "sutter-sync.png",
    altText: "Sutter Sync Image",
    title: "Sutter Sync",
    decorative: false,
  };

  return (
    <Box
      as="nav"
      position="fixed"
      top="0"
      left="0"
      width="100%"
      height="64px"
      bg="white"
      boxShadow="0px 4px 6px rgba(0, 0, 0, 0.1)"
      display="flex"
      alignItems="center"
      px={6}
      zIndex="9999"
    >
      {/* Left Side - Logo */}
      <Flex align="center" mt={2}>
        <ImageComponent image={image} variant="logo" />
      </Flex>

      {/* Spacer pushes the button to the rightmost edge */}
      <Spacer />

      {/* Right Side - Close Button */}
      <Button
        variant="plain"
        onClick={() => {
          setTimeout(() => {
            window.close();
          }, 2000);
        } }
        fontFamily="Sora"
        fontSize="20px"
        fontWeight="400"
        lineHeight="23.87px"
        textAlign="right"
        textDecoration="none"
        color="#646464"
      >
        Close
      </Button>
    </Box>
  );
};

export default NavBarComponent;
